import React from 'react';
import { connect } from 'react-redux';
import user from '../images/ic_account_circle.png';
import { formatDateOfBirth } from '../util/util';

class ResultBoxUser extends React.Component{
    constructor(props){
        super(props);
    }
    render=()=>{
        console.log(this.props.selectedUser);
        return(
            <div className="user-banner">
              <div class="floatLeft">
                <div class="userIcon"><img src={user} width="40" /></div>
                    <h5>{this.props.selectedUser.firstName} {this.props.selectedUser.lastName}</h5>
                    <p class="dob">{formatDateOfBirth(this.props.selectedUser.dateOfBirth, this.props.language)}</p>
                </div>
                <div>
                  <div class="floatRightMed">
                    <div class="med">{this.props.strings.MEDICARE}</div>
                        <div class="medNumber"><b>{this.props.strings.HCN_ISSUER[this.props.selectedUser.hcnIssuer] + " " + this.props.selectedUser.medicareNumber}</b></div>
                </div>
            </div>
          </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
        selectedUser: state.api.selectedUser,
    }
}

const ConnectedResultBoxUser = connect(
    mapStateToProps
)(ResultBoxUser);
export default ConnectedResultBoxUser;